import {useContext} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import FilterWrapperBasic, {filterWrapperBasicAllSelectionsId as allSelectionsId} from '@adv-mt/mt-filter-wrapper-basic'
import Select from '@adv-mt/mt-form-select'

import {getColorIconFromId, getColorLabelSelected} from './utils.js'

const LEGACY_WRAPPER = 'legacy'

const FormColor = ({
  value = [],
  onChange,
  initialSearch,
  isMultiSelect,
  overlayContentRef,
  pageName = '',
  type,
  withLabel = true,
  wrapper = LEGACY_WRAPPER
}) => {
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {colors, DEFAULT_COLOR, FILTER_NAMES} = config.get('search')
  const TRACKING_FILTER_NAMES = config.get('TRACKING_FILTER_NAMES')
  const FIRST_OPTION = {id: DEFAULT_COLOR, label: i18n.t('COMMON.ALL')}
  const localizedColors = colors.map(({id, label}) => ({
    id,
    label: i18n.t(label)
  }))

  const options = isMultiSelect ? localizedColors : [FIRST_OPTION, ...localizedColors]

  const _handleOnChange = (e, {value}) => {
    onChange(e, {
      field: FILTER_NAMES.COLOR,
      value: Array.isArray(value) ? value : [value],
      lastFilter: TRACKING_FILTER_NAMES[FILTER_NAMES.COLOR]
    })
  }

  const currentValue = value.length > 0 ? value : []

  if (wrapper === LEGACY_WRAPPER) {
    return (
      <Select
        field={FILTER_NAMES.COLOR}
        initialSearch={initialSearch}
        isMultiSelect={isMultiSelect}
        label={i18n.t('COMMON.COLOR')}
        onChange={_handleOnChange}
        options={options}
        overlayContentRef={overlayContentRef}
        pageName={pageName}
        placeholder={i18n.t('COMMON.ALL')}
        value={currentValue}
      />
    )
  }

  return (
    <FilterWrapperBasic
      filters={[
        {
          allSelectionsLabel: i18n.t('COMMON.ALL'),
          label: i18n.t('COMMON.COLOR'),
          name: FILTER_NAMES.COLOR,
          options: localizedColors.map(item => ({
            ...item,
            element: item.id ? getColorIconFromId({id: item.id}) : null
          })),
          type
        }
      ]}
      group={`${FILTER_NAMES.COLOR}Group`}
      legend={i18n.t('COMMON.COLOR')}
      onChange={({value}) => {
        _handleOnChange(null, {value: value.filter(id => id !== allSelectionsId)})
      }}
      overlayContentRef={overlayContentRef}
      placeholder={value.length ? getColorLabelSelected({colorsOptions: localizedColors, value}) : i18n.t('COMMON.ALL')}
      showLegend={withLabel}
      value={{[FILTER_NAMES.COLOR]: value.length ? value.map(value => String(value)) : [allSelectionsId]}}
      wrapper={wrapper}
    />
  )
}

FormColor.displayName = 'FormColor'
FormColor.propTypes = {
  initialSearch: PropTypes.object,
  isMultiSelect: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  overlayContentRef: PropTypes.node,
  pageName: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  withLabel: PropTypes.bool,
  wrapper: PropTypes.string
}

export default FormColor
